import { InjectionToken } from '@angular/core';

export const LOCAL_STORAGE = new InjectionToken('LOCAL_STORAGE', {
    factory: () => window.localStorage
});
